import { render, staticRenderFns } from "./FormTemplateFileQuestion.vue?vue&type=template&id=907bcc44&scoped=true&"
import script from "./FormTemplateFileQuestion.vue?vue&type=script&lang=js&"
export * from "./FormTemplateFileQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateFileQuestion.vue?vue&type=style&index=0&id=907bcc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907bcc44",
  null
  
)

export default component.exports